import { render, staticRenderFns } from "./TourDetailStatus.vue?vue&type=template&id=0af3e121"
import script from "./TourDetailStatus.js?vue&type=script&lang=js&external"
export * from "./TourDetailStatus.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports